import { render } from "./GoalsSection.vue?vue&type=template&id=3d7c4079&scoped=true"
import script from "./GoalsSection.vue?vue&type=script&lang=js"
export * from "./GoalsSection.vue?vue&type=script&lang=js"

import "./GoalsSection.vue?vue&type=style&index=0&id=3d7c4079&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7c4079"]])

export default __exports__